import { render, staticRenderFns } from "./BlogSectionSimpleSlider.vue?vue&type=template&id=0f5cde28"
import script from "./BlogSectionSimpleSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogSectionSimpleSlider.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports